__turbopack_context__.v({
  "stubWrapper": "image-with-stub-module__xG7IVq__stubWrapper",
});
